const getFileType = (mimeType) => /^[^\/]+/.exec(mimeType)[0];

export default getFileType;
